// Loader.js
import React from 'react';
import '../assets/css/Loader.css'; // Animasyon stil dosyası
import loadingGif from '../img/pre.gif'; // GIF dosyanızın yolunu buraya ekleyin

function Loader() {
  return (
    <div className="loader-container">
      <img src={loadingGif} alt="Loading..." className="loader-gif" />
    </div>
  );
}

export default Loader;